import { render, staticRenderFns } from "./ValuationSettings.vue?vue&type=template&id=c21c1212&"
import script from "./ValuationSettings.vue?vue&type=script&lang=ts&"
export * from "./ValuationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports